document.addEventListener('DOMContentLoaded', () => {
    const sectionElement = document.querySelector('.pdp-section');
    if (!sectionElement) return;

    const sectionId = sectionElement.getAttribute('data-section');
    
    initGallery();
    initVariantPicker(sectionId);
    initBundles(sectionId);
});

// 1. IMAGE GALLERY (Thumbnail Clicks)
function initGallery() {
    const mainImg = document.getElementById('pdpMain');
    const thumbnails = document.querySelectorAll('.pdp-thumb, .pdp-grid-img');

    if (!mainImg || !thumbnails.length) return;

    thumbnails.forEach(thumb => {
        thumb.addEventListener('click', function() {
            document.querySelectorAll('.pdp-thumb, .pdp-grid-img').forEach(t => t.classList.remove('active'));
            this.classList.add('active');

            const newSrc = this.getAttribute('data-main-img');
            mainImg.style.opacity = '0.5'; 
            setTimeout(() => { 
                mainImg.setAttribute('src', newSrc); 
                mainImg.style.opacity = '1'; 
            }, 150);
        });
    });
}

// 2. VARIANT SELECTION (Dynamic Fetching)
function initVariantPicker(sectionId) {
    const productJsonEl = document.getElementById(`ProductJson-${sectionId}`);
    if(!productJsonEl) return;
    
    const productData = JSON.parse(productJsonEl.innerHTML);

    document.addEventListener('change', (event) => {
        if (!event.target.classList.contains('variant-input')) return;

        const input = event.target;
        
        // --- A. Update UI Classes ---
        const wrapper = input.closest('.variant-wrapper');
        const labels = wrapper.querySelectorAll('label');
        
        labels.forEach(label => {
            label.classList.remove('active');
            const checkIcon = label.querySelector('.fa-check');
            if(checkIcon) checkIcon.classList.add('d-none');
        });

        const selectedLabel = wrapper.querySelector(`label[for="${input.id}"]`);
        if (selectedLabel) {
            selectedLabel.classList.add('active');
            const checkIcon = selectedLabel.querySelector('.fa-check');
            if(checkIcon) checkIcon.classList.remove('d-none');
        }

        // --- B. Find Selected Variant Data ---
        const selectedOptions = Array.from(document.querySelectorAll('.variant-input:checked')).map(el => el.value);
        const matchedVariant = productData.variants.find(variant => {
            return variant.options.every((opt, i) => opt === selectedOptions[i]);
        });

        if (matchedVariant) {
            // Update hidden ID
            document.getElementById(`VariantId-${sectionId}`).value = matchedVariant.id;
            // Seamlessly update browser URL
            window.history.replaceState({}, '', `${window.location.pathname}?variant=${matchedVariant.id}`);
            
            // --- C. Re-render Shopify blocks via API ---
            fetch(`${window.location.pathname}?variant=${matchedVariant.id}&section_id=${sectionId}`)
                .then(res => res.text())
                .then(html => {
                    const newDoc = new DOMParser().parseFromString(html, 'text/html');
                    
                    // 1. Update Price, Inventory, Buttons
                    ['Price', 'Inventory', 'BuyButtons'].forEach(block => {
                        const elId = `${block}-${sectionId}`;
                        if(document.getElementById(elId) && newDoc.getElementById(elId)) {
                            document.getElementById(elId).innerHTML = newDoc.getElementById(elId).innerHTML;
                        }
                    });

                    // 2. Update Main Image directly from fetched HTML
                    const imageWrapperId = `ProductImageWrapper-${sectionId}`;
                    const currentImgWrapper = document.getElementById(imageWrapperId);
                    const newImgWrapper = newDoc.getElementById(imageWrapperId);
                    
                    // A free gift choice ("Free Sock Size") never changes which product photo is shown,
                    // and the free gift box pre-selects Large on load, so it must not replace the
                    // main picture (the poster bundle leads with its "8 POSTER DESIGNS" picture).
                    const changedFreeGift = /free/i.test(input.name || '');
                    // Same photo (every size of one color shares it): leave it alone.
                    const photoPath = (wrap) => {
                        const img = wrap && wrap.querySelector('img');
                        return img ? (img.getAttribute('src') || '').split('?')[0] : '';
                    };
                    const samePhoto = photoPath(currentImgWrapper) !== '' && photoPath(currentImgWrapper) === photoPath(newImgWrapper);
                    if(currentImgWrapper && newImgWrapper && !changedFreeGift && !samePhoto) {
                        const mainImg = currentImgWrapper.querySelector('img');
                        if(mainImg) mainImg.style.opacity = '0.5';

                        setTimeout(() => {
                            // Hold the photo's height while the new one loads. Without this the
                            // box collapsed for a moment and everything below (sizes, packs,
                            // Add to Cart) jumped up ~350 px and back on every size tap
                            // (layout shift 1.3 on a phone, 2026-11-01).
                            currentImgWrapper.style.minHeight = currentImgWrapper.offsetHeight + 'px';
                            currentImgWrapper.innerHTML = newImgWrapper.innerHTML;
                            const newImg = currentImgWrapper.querySelector('img');
                            const release = () => { currentImgWrapper.style.minHeight = ''; };
                            if (newImg && !newImg.complete) {
                                newImg.loading = 'eager';
                                newImg.addEventListener('load', release, { once: true });
                                newImg.addEventListener('error', release, { once: true });
                                setTimeout(release, 4000);
                            } else {
                                release();
                            }

                            // Highlight the matching thumbnail visually
                            if (matchedVariant.featured_media) {
                                document.querySelectorAll('.pdp-thumb, .pdp-grid-img').forEach(t => t.classList.remove('active'));
                                const targetThumb = document.querySelector(`[data-media-id="${matchedVariant.featured_media.id}"]`);
                                if (targetThumb) targetThumb.classList.add('active');
                            }
                        }, 150);
                    }
                    
                    // 3. Recalculate Bundles
                    updateBundleMath(matchedVariant.price);
                });
        }
    });
}

// 3. SOCK PACKS (1 / 3 / 6 pairs)
// The 10% (3+) and 20% (6+) discounts are automatic in the cart; this only
// shows them. Add to Cart lives in BuyButtons, which is re-rendered on every
// variant change, so its price is re-applied after each render, never cached.
let awPackPriceCents = null;

const awFormatMoney = (cents) => '$' + (cents / 100).toFixed(2);
const awPackPercent = (qty) => (qty >= 6 ? 20 : qty >= 3 ? 10 : 0);
// Shopify takes the percentage off each pair and rounds it down to the cent
// (20% of $12.49 = $2.49 off, so $10.00 a pair). Match it exactly.
const awPairPrice = (cents, pct) => cents - Math.floor(cents * pct / 100);
const awSectionId = () => {
    const el = document.querySelector('.pdp-section');
    return el ? el.getAttribute('data-section') : null;
};

function initBundles(sectionId) {
    const bundles = document.querySelectorAll('.bundle-card');
    if (!bundles.length) return;
    const qtySelect = document.getElementById(`Quantity-${sectionId}`);

    const initialPriceEl = document.getElementById(`Price-${sectionId}`);
    if (initialPriceEl) {
        const cents = Math.round(parseFloat(initialPriceEl.innerText.replace(/[^0-9.]/g, '')) * 100);
        if (!isNaN(cents)) updateBundleMath(cents);
    }

    const select = (card) => {
        bundles.forEach(b => {
            const on = b === card;
            b.classList.toggle('active', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
    };

    bundles.forEach(bundle => {
        const choose = () => {
            select(bundle);
            if (qtySelect) qtySelect.value = bundle.getAttribute('data-qty');
            updateAtcPrice(sectionId);
        };
        bundle.addEventListener('click', choose);
        bundle.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
        });
    });

    if (qtySelect) {
        const sync = () => {
            const val = parseInt(qtySelect.value) || 1;
            const card = document.querySelector(`.bundle-card[data-qty="${val >= 6 ? 6 : val >= 3 ? 3 : 1}"]`);
            if (card) select(card);
            updateAtcPrice(sectionId);
        };
        qtySelect.addEventListener('change', sync);
        qtySelect.addEventListener('input', sync);
        // The - / + buttons change the value without firing an event.
        document.querySelectorAll('.qty-btn').forEach(b => b.addEventListener('click', () => setTimeout(sync, 0)));
    }

    // BuyButtons is replaced wholesale on variant change: watch the container.
    const container = document.getElementById(`BuyButtons-${sectionId}`);
    if (container && 'MutationObserver' in window) {
        new MutationObserver(() => updateAtcPrice(sectionId)).observe(container, { childList: true });
    }
    updateAtcPrice(sectionId);
}

function updateAtcPrice(sectionId) {
    if (awPackPriceCents === null || !document.querySelector('.bundle-card')) return;
    const qtySelect = document.getElementById(`Quantity-${sectionId}`);
    const btnPrice = document.querySelector(`#AddToCartBtn-${sectionId} .btn-price`);
    if (!btnPrice) return;
    const qty = Math.max(1, parseInt(qtySelect && qtySelect.value) || 1);
    const total = awPairPrice(awPackPriceCents, awPackPercent(qty)) * qty;
    const text = qty > 1 ? `${qty} for ${awFormatMoney(total)}` : awFormatMoney(total);
    if (btnPrice.textContent.trim() !== text) btnPrice.textContent = text;
}

function updateBundleMath(priceInCents) {
    awPackPriceCents = priceInCents;
    document.querySelectorAll('.bundle-card').forEach(card => {
        const qty = parseInt(card.getAttribute('data-qty'));
        const pct = parseInt(card.getAttribute('data-discount') || 0);
        if (qty === 1) {
            const priceEl = card.querySelector('.bundle-price');
            if (priceEl) priceEl.textContent = awFormatMoney(priceInCents);
            return;
        }
        const perPair = card.querySelector('.bundle-price-discounted');
        const compare = card.querySelector('.bundle-compare-price');
        const total = card.querySelector('.bundle-total');
        if (perPair) perPair.innerHTML = `${awFormatMoney(awPairPrice(priceInCents, pct))}<small>/pair</small>`;
        if (compare) compare.textContent = awFormatMoney(priceInCents * qty);
        if (total) total.textContent = awFormatMoney(awPairPrice(priceInCents, pct) * qty);
    });
    const sectionId = awSectionId();
    if (sectionId) updateAtcPrice(sectionId);
}